import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { defineComponent as _defineComponent } from 'vue';
import { getCurrentInstance } from 'vue';
import BHeader from '~/components/general/BHeader.vue';
import BSelect from '~/components/general/BSelect.vue';
import BLoader from '~/components/general/BLoader.vue';
import { EVENT_STATES, EVENT_TYPES } from '~/utils/utils';
import BAlert from '~/components/general/BAlert.vue';
import { convertDateToDisplay } from '~/utils/date-time';
import { useEventsStore } from '~/store/events';
import { useUserStore } from '~/store/user';
import { useAppStore, DashboardMenuItem, DashboardMenuState } from '~/store/app';
import IconCalendar from '~/components/general/icons/IconCalendar.vue';
import IconLocation from '~/components/general/icons/IconLocation.vue';
import IconPeople from '~/components/general/icons/IconPeople.vue';
import IconReporting from '~/components/general/icons/IconReporting.vue';
import IconOrders from '~/components/general/icons/IconOrders.vue';
import IconApiKey from '~/components/general/icons/IconApiKey.vue';
import IconArrowSwapHorizontal from '~/components/general/icons/IconArrowSwapHorizontal.vue';
import IconUserTag from '~/components/general/icons/IconUserTag.vue';
import IconUserSquare from '~/components/general/icons/IconUserSquare.vue';
import IconGeneral from '~/components/general/icons/IconGeneral.vue';
import IconPassword from '~/components/general/icons/IconPassword.vue';
import IconPrivacy from '~/components/general/icons/IconPrivacy.vue';
import IconClipboard from '~/components/general/icons/IconClipboard.vue';
import NotificationIcon from '~/components/common/icons/Notification.vue';
import IconMail from '~/components/common/icons/MailLight.vue';
import IconDocument from '~/components/general/icons/IconDocument.vue';
import IconOrganizerSignup from '~/components/general/icons/IconOrganizerSignup.vue';
import IconAirdrop from '~/components/common/icons/AirDrop.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'organizer',
  setup: function setup(__props) {
    var userStore = useUserStore();
    var appStore = useAppStore();
    var eventsStore = useEventsStore();
    var route = useRoute();
    var router = useRouter();
    var auth = useAuth();
    var sdk = useSdk();
    var notifier = useNotifier();
    var _useI18n = useI18n(),
      t = _useI18n.t,
      locale = _useI18n.locale;
    var localePath = useLocalePath();
    var whitelabel = useWhitelabel();
    var whitelabelLite = useWhitelabelLite();
    var featureFlags = useFeatureFlags();
    var runtimeConfig = useRuntimeConfig();
    var bus = useNuxtEventBus();
    var instance = getCurrentInstance();
    var eventStates = EVENT_STATES;
    var eventTypes = EVENT_TYPES;
    var event = ref({});
    var organizers = ref([]);
    var organizer = ref(null);
    function handleTopLevelTourFinish() {
      localStorage.setItem('watchedTopLevelTour', 'true');
    }
    function handleEventLevelTourFinish() {
      localStorage.setItem('watchedEventLevelTour', 'true');
    }
    var topLevelTourSteps = [{
      target: '#pdfTemplates',
      header: {
        title: t('organizerTutorials.topLevelNavTour.pdfTemplates.title')
      },
      content: t('organizerTutorials.topLevelNavTour.pdfTemplates.content'),
      params: {
        enableScrolling: false
      }
    }, {
      target: '#orders',
      header: {
        title: t('organizerTutorials.topLevelNavTour.orders.title')
      },
      content: t('organizerTutorials.topLevelNavTour.orders.content'),
      params: {
        enableScrolling: false
      }
    }, {
      target: '#transactionRules',
      header: {
        title: t('organizerTutorials.topLevelNavTour.transactionRules.title')
      },
      content: t('organizerTutorials.topLevelNavTour.transactionRules.content'),
      params: {
        enableScrolling: false
      }
    }, {
      target: '#collections',
      header: {
        title: t('organizerTutorials.topLevelNavTour.nftCollectibles.title')
      },
      content: t('organizerTutorials.topLevelNavTour.nftCollectibles.content'),
      params: {
        enableScrolling: false
      }
    }, {
      target: '#users',
      header: {
        title: t('organizerTutorials.topLevelNavTour.users.title')
      },
      content: t('organizerTutorials.topLevelNavTour.users.content'),
      params: {
        enableScrolling: false
      }
    }];
    var eventLevelTourSteps = [{
      target: '#occurrences',
      header: {
        title: t('organizerTutorials.eventLevelNavTour.occurrences.title')
      },
      content: t('organizerTutorials.eventLevelNavTour.occurrences.content'),
      params: {
        enableScrolling: false
      }
    }, {
      target: '#ticketNFTMedia',
      header: {
        title: t('organizerTutorials.eventLevelNavTour.nftMedia.title')
      },
      content: t('organizerTutorials.eventLevelNavTour.nftMedia.content'),
      params: {
        enableScrolling: false
      }
    }, {
      target: '#externalTickets',
      header: {
        title: t('organizerTutorials.eventLevelNavTour.externalTickets.title')
      },
      content: t('organizerTutorials.eventLevelNavTour.externalTickets.content'),
      params: {
        enableScrolling: false
      }
    }, {
      target: '#sponsorPromotions',
      header: {
        title: t('organizerTutorials.eventLevelNavTour.promotions.title')
      },
      content: t('organizerTutorials.eventLevelNavTour.promotions.content'),
      params: {
        enableScrolling: false
      }
    }, {
      target: '#questionnaires',
      header: {
        title: t('organizerTutorials.eventLevelNavTour.kyc.title')
      },
      content: t('organizerTutorials.eventLevelNavTour.kyc.content'),
      params: {
        enableScrolling: false
      }
    }, {
      target: '#sentTickets',
      header: {
        title: t('organizerTutorials.eventLevelNavTour.sendTickets.title')
      },
      content: t('organizerTutorials.eventLevelNavTour.sendTickets.content'),
      params: {
        enableScrolling: false
      }
    }];
    var topLevelTourCallbacks = {
      onSkip: handleTopLevelTourFinish,
      onFinish: handleTopLevelTourFinish
    };
    var eventLevelTourCallbacks = {
      onSkip: handleEventLevelTourFinish,
      onFinish: handleEventLevelTourFinish
    };
    useNuxt2Meta(function () {
      return {
        // This sets the lang attribute on the html tag
        // This, in turn, allows the cookie consent component to pick up the correct language
        htmlAttrs: {
          lang: locale.value
        }
      };
    });
    var canInviteUser = computed(function () {
      return userStore.canInviteUser;
    });
    var hasRoleForOrg = computed(function () {
      return userStore.hasRoleForOrg;
    });
    var canAccessMyEvents = computed(function () {
      return userStore.canAccessMyEvents;
    });
    var canAccessLocation = computed(function () {
      return userStore.canAccessLocation;
    });
    var canAccessTransactionRules = computed(function () {
      return userStore.canAccessTransactionRules;
    });
    var canAccessOrganizer = computed(function () {
      return userStore.canAccessOrganizer;
    });
    var canAccessUsers = computed(function () {
      return userStore.canAccessUsers;
    });
    var canAccessEventInfo = computed(function () {
      return userStore.canAccessEventInfo;
    });
    var canAccessReporting = computed(function () {
      return userStore.canAccessReporting;
    });
    var canAccessSendTickets = computed(function () {
      return userStore.canAccessSendTickets;
    });
    var canAccessViewOrders = computed(function () {
      return userStore.canAccessViewOrders;
    });
    var canAccessSoldTickets = computed(function () {
      return userStore.canAccessSoldTickets;
    });
    var canAccessSendEmails = computed(function () {
      return userStore.canAccessSendEmails;
    });
    var canAccessManageAccounts = computed(function () {
      return userStore.canAccessManageAccounts;
    });
    var canAccessNFTCollectibles = computed(function () {
      return userStore.canAccessNFTCollectibles;
    });
    var canSendEventNotifications = computed(function () {
      return userStore.canSendEventNotifications;
    });
    var canSendGlobalNotifications = computed(function () {
      return userStore.canSendGlobalNotifications;
    });
    var canAccessOrganizerApplications = computed(function () {
      return userStore.canAccessOrganizerApplications;
    });
    var canAccessEventPayouts = computed(function () {
      return userStore.canAccessEventPayouts;
    });
    var getUser = computed(function () {
      return userStore.getUser;
    });
    var getDashboardMenu = computed(function () {
      return appStore.getDashboardMenu;
    });
    var getDashboardMenuActive = computed(function () {
      return appStore.getDashboardMenuActive;
    });
    var getEventSendTickets = computed(function () {
      return appStore.getEventSendTickets;
    });
    var getOrganizer = computed(function () {
      return appStore.getOrganizer;
    });
    var getOrganizers = computed(function () {
      return appStore.getOrganizers;
    });
    var getOrganizerInToken = computed(function () {
      return appStore.getOrganizerInToken;
    });
    var getLoading = computed(function () {
      return appStore.getLoading;
    });
    var userCanAccessDashboard = computed(function () {
      return appStore.userCanAccessDashboard;
    });
    var getCurrentEvent = computed(function () {
      return eventsStore.getCurrentEvent;
    });
    var canAccessEvents = computed(function () {
      var _organizer$value, _organizer$value2;
      return canAccessMyEvents.value((_organizer$value = organizer.value) === null || _organizer$value === void 0 ? void 0 : _organizer$value.name) || canAccessLocation.value((_organizer$value2 = organizer.value) === null || _organizer$value2 === void 0 ? void 0 : _organizer$value2.name);
    });
    var canAccessSales = computed(function () {
      var _organizer$value3, _organizer$value4;
      return canAccessReporting.value((_organizer$value3 = organizer.value) === null || _organizer$value3 === void 0 ? void 0 : _organizer$value3.name) || canAccessViewOrders.value((_organizer$value4 = organizer.value) === null || _organizer$value4 === void 0 ? void 0 : _organizer$value4.name);
    });
    var canAccessMarketplace = computed(function () {
      var _organizer$value5;
      return canAccessTransactionRules.value((_organizer$value5 = organizer.value) === null || _organizer$value5 === void 0 ? void 0 : _organizer$value5.name);
    });
    var canAccessCollectibles = computed(function () {
      var _organizer$value6;
      return canAccessNFTCollectibles.value((_organizer$value6 = organizer.value) === null || _organizer$value6 === void 0 ? void 0 : _organizer$value6.name);
    });
    var canAccessOrganization = computed(function () {
      var _organizer$value7, _organizer$value8;
      return canAccessOrganizer.value((_organizer$value7 = organizer.value) === null || _organizer$value7 === void 0 ? void 0 : _organizer$value7.name) || canAccessUsers.value((_organizer$value8 = organizer.value) === null || _organizer$value8 === void 0 ? void 0 : _organizer$value8.name);
    });
    var canAccessPlatformAdmin = computed(function () {
      return canAccessManageAccounts.value(featureFlags.mainOrganizer) || canAccessOrganizerApplications.value(featureFlags.mainOrganizer) || canSendGlobalNotifications.value(featureFlags.mainOrganizer);
    });
    var isMainOrg = computed(function () {
      var _organizer$value9;
      return ((_organizer$value9 = organizer.value) === null || _organizer$value9 === void 0 ? void 0 : _organizer$value9.name) === featureFlags.mainOrganizer;
    });
    var isRecurring = computed(function () {
      return event.value.type === eventTypes.RECURRING;
    });
    var isOccurrence = computed(function () {
      return event.value.type === eventTypes.OCCURRENCE;
    });
    var isDraft = computed(function () {
      return event.value.status === eventStates.DRAFT;
    });
    var isEdit = computed(function () {
      return route.params.id !== undefined;
    });
    var headerColor = computed(function () {
      return whitelabel.lightTheme.backgroundPrimary.base;
    });
    var isRuleEditPage = computed(function () {
      return route.params.ruleId !== undefined;
    });
    var eventHasTicketConfigs = computed(function () {
      var _getCurrentEvent$valu;
      return ((_getCurrentEvent$valu = getCurrentEvent.value.ticketConfig) === null || _getCurrentEvent$valu === void 0 ? void 0 : _getCurrentEvent$valu.length) > 0;
    });
    var userMenuItems = computed(function () {
      return menuItems.value.filter(function (item) {
        item.subItems = item.subItems.filter(function (subItem) {
          return subItem.canAccess;
        });
        return item.subItems;
      });
    });
    var menuItems = computed(function () {
      var _organizer$value0, _organizer$value1, _organizer$value10, _organizer$value11, _organizer$value12, _organizer$value13, _organizer$value14, _organizer$value15, _organizer$value16, _organizer$value17;
      return [{
        label: t('sideMenu.events'),
        name: 'events',
        type: 'events',
        subItems: [{
          label: t('sideMenu.events'),
          name: DashboardMenuItem.MyEvents,
          icon: IconCalendar,
          onClick: function onClick() {
            router.push(localePath('/my-events'));
          },
          canAccess: canAccessMyEvents.value((_organizer$value0 = organizer.value) === null || _organizer$value0 === void 0 ? void 0 : _organizer$value0.name)
        }, {
          label: t('sideMenu.ticketTemplates'),
          name: DashboardMenuItem.PdfTemplates,
          icon: IconDocument,
          onClick: function onClick() {
            router.push(localePath('/pdf-templates'));
          },
          canAccess: canAccessMyEvents.value((_organizer$value1 = organizer.value) === null || _organizer$value1 === void 0 ? void 0 : _organizer$value1.name) && featureFlags.pdfTemplates
        }, {
          label: t('sideMenu.addVenue'),
          name: DashboardMenuItem.Location,
          icon: IconLocation,
          onClick: function onClick() {
            router.push(localePath('/location'));
          },
          canAccess: canAccessLocation.value((_organizer$value10 = organizer.value) === null || _organizer$value10 === void 0 ? void 0 : _organizer$value10.name)
        }]
      }, {
        label: t('sideMenu.sales'),
        name: 'sales',
        type: 'sales',
        subItems: [{
          label: t('sideMenu.analytics'),
          name: DashboardMenuItem.Reporting,
          icon: IconReporting,
          onClick: function onClick() {
            router.push(localePath('/reporting'));
          },
          canAccess: canAccessReporting.value((_organizer$value11 = organizer.value) === null || _organizer$value11 === void 0 ? void 0 : _organizer$value11.name) && featureFlags.showOrganizerReportsDashboard
        }, {
          label: t('sideMenu.orders'),
          name: DashboardMenuItem.Orders,
          icon: IconOrders,
          onClick: function onClick() {
            router.push(localePath('/orders'));
          },
          canAccess: canAccessViewOrders.value((_organizer$value12 = organizer.value) === null || _organizer$value12 === void 0 ? void 0 : _organizer$value12.name)
        }]
      }, {
        label: t('sideMenu.marketplace'),
        name: 'marketplace',
        type: 'marketplace',
        subItems: [{
          label: t('sideMenu.secondaryMarketRules'),
          name: DashboardMenuItem.TransactionRules,
          icon: IconArrowSwapHorizontal,
          onClick: function onClick() {
            router.push(localePath('/transaction-rules'));
          },
          canAccess: canAccessTransactionRules.value((_organizer$value13 = organizer.value) === null || _organizer$value13 === void 0 ? void 0 : _organizer$value13.name)
        }]
      }, {
        label: t('sideMenu.collectibles'),
        name: 'collectibles',
        type: 'collectibles',
        subItems: [{
          label: t('sideMenu.collections'),
          name: DashboardMenuItem.Collections,
          icon: IconClipboard,
          onClick: function onClick() {
            router.push(localePath('/nft-collectibles/collections'));
          },
          canAccess: canAccessNFTCollectibles.value((_organizer$value14 = organizer.value) === null || _organizer$value14 === void 0 ? void 0 : _organizer$value14.name) && featureFlags.showNftCollectibles
        }, {
          label: t('sideMenu.airdrops'),
          name: DashboardMenuItem.AirDrops,
          icon: IconAirdrop,
          onClick: function onClick() {
            router.push(localePath('/nft-collectibles/air-drops'));
          },
          canAccess: canAccessNFTCollectibles.value((_organizer$value15 = organizer.value) === null || _organizer$value15 === void 0 ? void 0 : _organizer$value15.name) && featureFlags.showNftCollectibles
        }]
      }, {
        label: t('sideMenu.organization'),
        name: 'organization',
        type: 'organization',
        subItems: [{
          label: t('sideMenu.organizers'),
          name: DashboardMenuItem.Organizers,
          icon: IconUserTag,
          onClick: function onClick() {
            router.push(localePath('/organizer/list'));
          },
          canAccess: canAccessOrganizer.value((_organizer$value16 = organizer.value) === null || _organizer$value16 === void 0 ? void 0 : _organizer$value16.name)
        }, {
          label: t('sideMenu.teamMembers'),
          name: DashboardMenuItem.Users,
          icon: IconUserSquare,
          onClick: function onClick() {
            router.push(localePath('/users'));
          },
          canAccess: canAccessUsers.value((_organizer$value17 = organizer.value) === null || _organizer$value17 === void 0 ? void 0 : _organizer$value17.name)
        }]
      }, {
        label: t('sideMenu.platformAdmin'),
        name: 'platformAdmin',
        type: 'platformAdmin',
        subItems: [{
          label: t('sideMenu.allAcounts'),
          name: DashboardMenuItem.ManageAccounts,
          icon: IconPeople,
          onClick: function onClick() {
            router.push(localePath('/manage-accounts'));
          },
          canAccess: canAccessManageAccounts.value(featureFlags.mainOrganizer)
        }, {
          label: t('sideMenu.organizerRequests'),
          name: DashboardMenuItem.OrganizerApplications,
          icon: IconOrganizerSignup,
          onClick: function onClick() {
            router.push(localePath('/organizer-applications'));
          },
          canAccess: canAccessOrganizerApplications.value(featureFlags.mainOrganizer)
        }, {
          label: t('sideMenu.broadcastNotifications'),
          name: DashboardMenuItem.SendNotifications,
          icon: NotificationIcon,
          onClick: function onClick() {
            router.push(localePath('/send-notifications'));
          },
          canAccess: canSendGlobalNotifications.value(featureFlags.mainOrganizer)
        }, {
          label: t('sideMenu.newsletters'),
          name: DashboardMenuItem.SendNewsletter,
          icon: IconMail,
          onClick: function onClick() {
            router.push(localePath('/send-newsletter'));
          },
          canAccess: canSendGlobalNotifications.value(featureFlags.mainOrganizer)
        }]
      }];
    });
    var eventUrl = computed(function () {
      var _organizer$value18;
      return localePath("/".concat(route.params.tenant, "/organizer/").concat((_organizer$value18 = organizer.value) === null || _organizer$value18 === void 0 ? void 0 : _organizer$value18.name, "/event/").concat(route.params.id));
    });
    var eventMenuItems = computed(function () {
      var _organizer$value19, _organizer$value20, _organizer$value21, _organizer$value22, _organizer$value23, _organizer$value24, _organizer$value25, _organizer$value26, _organizer$value27, _organizer$value28, _organizer$value29, _organizer$value30, _organizer$value31, _organizer$value32, _organizer$value33, _organizer$value34, _organizer$value35, _organizer$value36, _organizer$value37, _organizer$value38, _organizer$value39;
      return [{
        label: t('sideMenu.eventSetup'),
        name: 'eventSetup',
        hidden: isMainOrg.value,
        subItems: [{
          label: t('sideMenu.eventDetails'),
          name: DashboardMenuItem.EventDetails,
          hidden: isMainOrg.value,
          onClick: function onClick() {
            if (isEdit.value) {
              router.push(localePath("".concat(eventUrl.value, "/edit")));
            }
          },
          canAccess: canAccessEventInfo.value((_organizer$value19 = organizer.value) === null || _organizer$value19 === void 0 ? void 0 : _organizer$value19.name)
        }, {
          label: t('sideMenu.occurrences'),
          name: DashboardMenuItem.Occurrences,
          hidden: isMainOrg.value,
          disabled: !isRecurring.value,
          onClick: function onClick() {
            router.push(localePath("".concat(eventUrl.value, "/occurrences")));
          },
          canAccess: canAccessEventInfo.value((_organizer$value20 = organizer.value) === null || _organizer$value20 === void 0 ? void 0 : _organizer$value20.name)
        }]
      }, {
        label: t('sideMenu.tickets'),
        name: 'eventTickets',
        hidden: isMainOrg.value,
        subItems: [{
          label: t('sideMenu.ticketCategories'),
          name: DashboardMenuItem.TicketCategories,
          hidden: isMainOrg.value,
          disabled: !isEdit.value,
          onClick: function onClick() {
            router.push(localePath("".concat(eventUrl.value, "/tickets")));
          },
          canAccess: canAccessEventInfo.value((_organizer$value21 = organizer.value) === null || _organizer$value21 === void 0 ? void 0 : _organizer$value21.name)
        }, {
          label: t('sideMenu.ticketNftMedia'),
          name: DashboardMenuItem.TicketNftMedia,
          hidden: isMainOrg.value,
          disabled: !isEdit.value || !eventHasTicketConfigs.value,
          onClick: function onClick() {
            router.push(localePath("".concat(eventUrl.value, "/tickets-media")));
          },
          canAccess: canAccessEventInfo.value((_organizer$value22 = organizer.value) === null || _organizer$value22 === void 0 ? void 0 : _organizer$value22.name)
        }, {
          label: t('sideMenu.externalTickets'),
          name: DashboardMenuItem.ExternalTickets,
          hidden: isRecurring.value || isMainOrg.value,
          disabled: !isEdit.value,
          onClick: function onClick() {
            router.push(localePath("".concat(eventUrl.value, "/external-tickets")));
          },
          canAccess: canAccessEventInfo.value((_organizer$value23 = organizer.value) === null || _organizer$value23 === void 0 ? void 0 : _organizer$value23.name)
        }]
      }, {
        label: t('sideMenu.accessAndPricing'),
        name: 'accessAndPricing',
        hidden: isMainOrg.value,
        subItems: [{
          label: t('sideMenu.presaleCodes'),
          name: DashboardMenuItem.PresaleCodes,
          hidden: isRecurring.value || isMainOrg.value,
          disabled: !isEdit.value || !eventHasTicketConfigs.value,
          onClick: function onClick() {
            router.push(localePath("".concat(eventUrl.value, "/presale-access-codes")));
          },
          canAccess: canAccessEventInfo.value((_organizer$value24 = organizer.value) === null || _organizer$value24 === void 0 ? void 0 : _organizer$value24.name)
        }, {
          label: t('sideMenu.discounts'),
          name: DashboardMenuItem.Discounts,
          hidden: isRecurring.value || isMainOrg.value,
          disabled: !isEdit.value || !eventHasTicketConfigs.value,
          onClick: function onClick() {
            router.push(localePath("".concat(eventUrl.value, "/discounts")));
          },
          canAccess: canAccessEventInfo.value((_organizer$value25 = organizer.value) === null || _organizer$value25 === void 0 ? void 0 : _organizer$value25.name)
        }, {
          label: t('sideMenu.sponsorPromotions'),
          name: DashboardMenuItem.SponsorPromotions,
          hidden: isMainOrg.value,
          disabled: !isEdit.value || !eventHasTicketConfigs.value,
          onClick: function onClick() {
            router.push(localePath("".concat(eventUrl.value, "/tickets/promotions")));
          },
          canAccess: canAccessEventInfo.value((_organizer$value26 = organizer.value) === null || _organizer$value26 === void 0 ? void 0 : _organizer$value26.name)
        }]
      }, {
        label: t('sideMenu.capacityAndEntry'),
        name: 'capacityAndEntry',
        hidden: isRecurring.value || isMainOrg.value,
        subItems: [{
          label: t('sideMenu.sectors'),
          name: DashboardMenuItem.Sectors,
          hidden: isRecurring.value || isMainOrg.value,
          disabled: !isEdit.value || !eventHasTicketConfigs.value,
          onClick: function onClick() {
            router.push(localePath("".concat(eventUrl.value, "/sectors")));
          },
          canAccess: canAccessEventInfo.value((_organizer$value27 = organizer.value) === null || _organizer$value27 === void 0 ? void 0 : _organizer$value27.name)
        }, {
          label: t('sideMenu.entryTimeslots'),
          name: DashboardMenuItem.EntryTimeslots,
          hidden: isRecurring.value || isMainOrg.value,
          disabled: !eventHasTicketConfigs.value || !isEdit.value,
          onClick: function onClick() {
            router.push(localePath("".concat(eventUrl.value, "/timeslots")));
          },
          canAccess: canAccessEventInfo.value((_organizer$value28 = organizer.value) === null || _organizer$value28 === void 0 ? void 0 : _organizer$value28.name)
        }]
      }, {
        label: t('sideMenu.seating'),
        name: 'seating',
        hidden: isRecurring.value || isMainOrg.value,
        subItems: [{
          label: t('sideMenu.floorplanDesigner'),
          name: DashboardMenuItem.FloorplanDesigner,
          hidden: isRecurring.value || isMainOrg.value,
          disabled: !eventHasTicketConfigs.value || !isEdit.value,
          onClick: function onClick() {
            router.push(localePath("".concat(eventUrl.value, "/seatmap/chart")));
          },
          canAccess: canAccessEventInfo.value((_organizer$value29 = organizer.value) === null || _organizer$value29 === void 0 ? void 0 : _organizer$value29.name)
        }, {
          label: t('sideMenu.seatManagement'),
          name: DashboardMenuItem.SeatManagement,
          hidden: isRecurring.value || isMainOrg.value,
          disabled: !eventHasTicketConfigs.value || !isEdit.value,
          onClick: function onClick() {
            router.push(localePath("".concat(eventUrl.value, "/seatmap/manage-seats")));
          },
          canAccess: canAccessEventInfo.value((_organizer$value30 = organizer.value) === null || _organizer$value30 === void 0 ? void 0 : _organizer$value30.name)
        }]
      }, {
        label: t('sideMenu.kyc'),
        name: 'kyc',
        hidden: isRecurring.value || isMainOrg.value,
        subItems: [{
          label: t('sideMenu.questionnaires'),
          name: DashboardMenuItem.Questionnaires,
          hidden: isRecurring.value || isMainOrg.value,
          disabled: !eventHasTicketConfigs.value || !isEdit.value,
          onClick: function onClick() {
            router.push(localePath("/".concat(route.params.tenant, "/organizer/").concat(route.params.organizerName, "/event/").concat(route.params.id, "/questionnaire/add")));
          },
          canAccess: canAccessEventInfo.value((_organizer$value31 = organizer.value) === null || _organizer$value31 === void 0 ? void 0 : _organizer$value31.name)
        }, {
          label: t('sideMenu.questionnaireAssignments'),
          name: DashboardMenuItem.QuestionnaireAssignments,
          hidden: isRecurring.value || isMainOrg.value,
          disabled: !eventHasTicketConfigs.value || !isEdit.value,
          onClick: function onClick() {
            router.push(localePath("/".concat(route.params.tenant, "/organizer/").concat(route.params.organizerName, "/event/").concat(route.params.id, "/questionnaire/manage")));
          },
          canAccess: canAccessEventInfo.value((_organizer$value32 = organizer.value) === null || _organizer$value32 === void 0 ? void 0 : _organizer$value32.name)
        }]
      }, {
        label: t('sideMenu.sales'),
        name: 'sales',
        hidden: isRecurring.value || isMainOrg.value,
        subItems: [{
          label: t('sideMenu.orders'),
          name: DashboardMenuItem.Orders,
          disabled: !isEdit.value,
          hidden: isRecurring.value || isMainOrg.value,
          onClick: function onClick() {
            router.push(localePath("".concat(eventUrl.value, "/orders")));
          },
          canAccess: canAccessViewOrders.value((_organizer$value33 = organizer.value) === null || _organizer$value33 === void 0 ? void 0 : _organizer$value33.name)
        }, {
          label: t('sideMenu.soldTickets'),
          name: DashboardMenuItem.SoldTickets,
          disabled: !isEdit.value,
          hidden: isRecurring.value || isMainOrg.value,
          onClick: function onClick() {
            router.push(localePath("".concat(eventUrl.value, "/sold-tickets")));
          },
          canAccess: canAccessSoldTickets.value((_organizer$value34 = organizer.value) === null || _organizer$value34 === void 0 ? void 0 : _organizer$value34.name)
        }, {
          label: t('sideMenu.guestlist'),
          name: DashboardMenuItem.SentTickets,
          disabled: !getEventSendTickets.value || !isEdit.value,
          hidden: isRecurring.value || isMainOrg.value,
          onClick: function onClick() {
            router.push(localePath("".concat(eventUrl.value, "/send-tickets")));
          },
          canAccess: canAccessSendTickets.value((_organizer$value35 = organizer.value) === null || _organizer$value35 === void 0 ? void 0 : _organizer$value35.name)
        }]
      }, {
        label: t('sideMenu.messaging'),
        name: 'messaging',
        hidden: isRecurring.value || isMainOrg.value,
        subItems: [{
          label: t('sideMenu.emails'),
          name: DashboardMenuItem.Emails,
          disabled: !isEdit.value || isDraft.value,
          hidden: isRecurring.value || isMainOrg.value,
          onClick: function onClick() {
            router.push(localePath("".concat(eventUrl.value, "/send-emails")));
          },
          canAccess: canAccessSendEmails.value((_organizer$value36 = organizer.value) === null || _organizer$value36 === void 0 ? void 0 : _organizer$value36.name)
        }, {
          label: t('sideMenu.pushNotifications'),
          name: DashboardMenuItem.PushNotifications,
          disabled: !isEdit.value || isDraft.value || !eventHasTicketConfigs.value,
          hidden: isRecurring.value || isMainOrg.value,
          onClick: function onClick() {
            router.push(localePath("".concat(eventUrl.value, "/send-notifications")));
          },
          canAccess: canSendEventNotifications.value((_organizer$value37 = organizer.value) === null || _organizer$value37 === void 0 ? void 0 : _organizer$value37.name)
        }]
      }, {
        label: t('sideMenu.analytics'),
        name: 'analytics',
        hidden: !featureFlags.showReportsDashboard,
        subItems: [{
          label: t('sideMenu.analytics'),
          name: DashboardMenuItem.Analytics,
          disabled: !isEdit.value,
          hidden: !featureFlags.showReportsDashboard || isMainOrg.value,
          onClick: function onClick() {
            router.push(localePath("".concat(eventUrl.value, "/reporting")));
          },
          canAccess: canAccessReporting.value((_organizer$value38 = organizer.value) === null || _organizer$value38 === void 0 ? void 0 : _organizer$value38.name)
        }, {
          label: t('sideMenu.payouts'),
          name: DashboardMenuItem.Payouts,
          disabled: !isEdit.value || isDraft.value,
          hidden: !featureFlags.showReportsDashboard || isOccurrence.value,
          onClick: function onClick() {
            router.push(localePath("/".concat(route.params.tenant, "/organizer/").concat(route.params.organizerName, "/event/").concat(route.params.id, "/payouts")));
          },
          canAccess: canAccessEventPayouts.value((_organizer$value39 = organizer.value) === null || _organizer$value39 === void 0 ? void 0 : _organizer$value39.name, featureFlags.mainOrganizer)
        }]
      }];
    });
    var profileMenuItems = computed(function () {
      return [{
        label: t('sideMenu.profile'),
        name: 'profile',
        type: 'profile',
        hidden: false,
        subItems: [{
          label: t('sideMenu.profile.general'),
          name: DashboardMenuItem.General,
          icon: IconGeneral,
          hidden: false,
          onClick: function onClick() {
            router.push(localePath('/profile'));
          },
          canAccess: true
        }, {
          label: t('sideMenu.profile.password'),
          name: DashboardMenuItem.Password,
          icon: IconPassword,
          hidden: false,
          onClick: function onClick() {
            router.push(localePath('/profile/password'));
          },
          canAccess: true
        }, {
          label: t('sideMenu.profile.privacy'),
          name: DashboardMenuItem.Privacy,
          icon: IconPrivacy,
          hidden: false,
          onClick: function onClick() {
            router.push(localePath('/profile/privacy'));
          },
          canAccess: true
        }]
      }, {
        label: t('sideMenu.profile.reporting'),
        name: 'reporting',
        type: 'reporting',
        hidden: false,
        subItems: [{
          label: t('sideMenu.profile.orders'),
          name: DashboardMenuItem.Orders,
          icon: IconOrders,
          hidden: false,
          onClick: function onClick() {
            router.push(localePath('/profile/orders'));
          },
          canAccess: true
        }, {
          label: t('organizerSignup.becomeAnOrganizer'),
          name: DashboardMenuItem.OrganizerSignup,
          icon: IconOrganizerSignup,
          hidden: userCanAccessDashboard.value || !featureFlags.showOrganizerOnboarding,
          onClick: function onClick() {
            router.push(localePath('/organizer-signup'));
          },
          canAccess: emailVerified.value,
          disabled: !emailVerified.value
        }]
      }, {
        label: t('sideMenu.profile.integrations'),
        name: 'integrations',
        type: 'integrations',
        hidden: !userCanAccessDashboard.value,
        subItems: [{
          label: t('sideMenu.profile.apiKeys'),
          name: DashboardMenuItem.ApiKeys,
          icon: IconApiKey,
          hidden: !userCanAccessDashboard.value,
          onClick: function onClick() {
            router.push(localePath('/profile/api-keys'));
          },
          canAccess: userCanAccessDashboard.value
        }]
      }];
    });
    var urlHasEventId = computed(function () {
      return route.params.id;
    });
    var logoUrl = computed(function () {
      var _whitelabelLite$wordm;
      return (_whitelabelLite$wordm = whitelabelLite === null || whitelabelLite === void 0 ? void 0 : whitelabelLite.wordmarkUrl) !== null && _whitelabelLite$wordm !== void 0 ? _whitelabelLite$wordm : require('assets/img/logo_dashboard.svg');
    });
    var emailVerified = computed(function () {
      var _auth$user;
      return !!(auth !== null && auth !== void 0 && (_auth$user = auth.user) !== null && _auth$user !== void 0 && _auth$user.verified);
    });
    watch(urlHasEventId, function (newValue) {
      if (newValue) {
        getEvent();
      }
    });
    function getEvent() {
      return _getEvent.apply(this, arguments);
    }
    function _getEvent() {
      _getEvent = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var fetchedEvent, convertedDate, _e$response, _t;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 1;
              return sdk.event.getOrganizerEvent({
                organizerId: route.params.organizerName,
                id: parseInt(route.params.id)
              }, {
                with: {
                  ticket_config: {
                    depends_on: true
                  },
                  subcategory: true,
                  ticket_format: true
                }
              });
            case 1:
              fetchedEvent = _context2.sent;
              eventsStore.setCurrentEvent(fetchedEvent);
              event.value = fetchedEvent;
              convertedDate = convertDateToDisplay(event.value.startAt, event.value.timezoneName);
              appStore.setDashboardMenu({
                state: DashboardMenuState.Event,
                active: DashboardMenuItem.EventDetails,
                event: {
                  name: event.value.name,
                  date: instance === null || instance === void 0 ? void 0 : instance.proxy.$d(convertedDate, 'DD_MM_YYYY'),
                  time: instance === null || instance === void 0 ? void 0 : instance.proxy.$d(convertedDate, 'HH_mm')
                }
              });
              bus.$emit('currentEventReady');
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t = _context2["catch"](0);
              if ((_t === null || _t === void 0 ? void 0 : (_e$response = _t.response) === null || _e$response === void 0 ? void 0 : _e$response.status) === 401) {
                notifier.showMessage({
                  content: t('errors.editEventPermissions'),
                  type: 'error'
                });
                router.replace(localePath('/'));
              } else {
                notifier.showMessage({
                  content: t('errors.fetchEvent'),
                  type: 'error'
                });
              }
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 2]]);
      }));
      return _getEvent.apply(this, arguments);
    }
    function organizerSelected(_x) {
      return _organizerSelected.apply(this, arguments);
    }
    function _organizerSelected() {
      _organizerSelected = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(selectedOrgId) {
        var oldOrgName, orgChangeHappened;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (auth.loggedIn) {
                _context3.next = 1;
                break;
              }
              return _context3.abrupt("return");
            case 1:
              oldOrgName = getOrganizer.value.name;
              organizer.value = organizers.value.find(function (org) {
                return org.id === selectedOrgId;
              });
              orgChangeHappened = oldOrgName !== organizer.value.name;
              appStore.setOrganizer(organizer.value);

              // Avoids the infinite loop when doing an impersonate
              if (!orgChangeHappened) {
                _context3.next = 2;
                break;
              }
              _context3.next = 2;
              return changeToOrg(getOrganizer.value.name);
            case 2:
              bus.$emit('orgSelected', organizer.value);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _organizerSelected.apply(this, arguments);
    }
    function changeToOrg(_x2) {
      return _changeToOrg.apply(this, arguments);
    }
    function _changeToOrg() {
      _changeToOrg = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(organizerName) {
        var _t2;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 1;
              return sdk.useOrganizer(organizerName);
            case 1:
              appStore.setOrganizerInToken(organizerName);
              _context4.next = 3;
              break;
            case 2:
              _context4.prev = 2;
              _t2 = _context4["catch"](0);
              auth.logout();
              userStore.resetUser();
              appStore.clearAuthData();
              gotoHome();
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 2]]);
      }));
      return _changeToOrg.apply(this, arguments);
    }
    function gotoHome() {
      router.push(localePath('/'));
    }
    function gotoEvents() {
      router.push(localePath('/my-events'));
    }
    function handleTopLevelTour() {
      var watchedTopLevelTour = localStorage.getItem('watchedTopLevelTour');
      if (watchedTopLevelTour !== 'true') {
        instance === null || instance === void 0 ? void 0 : instance.proxy.$tours.topLevelNavigationTour.start();
      }
    }
    function handleEventLevelTour() {
      var watchedEventLevelTour = localStorage.getItem('watchedEventLevelTour');
      if (watchedEventLevelTour !== 'true') {
        instance === null || instance === void 0 ? void 0 : instance.proxy.$tours.eventLevelNavigationTour.start();
      }
    }
    function handleHelpClick() {
      instance === null || instance === void 0 ? void 0 : instance.proxy.$tours.topLevelNavigationTour.start();
      instance === null || instance === void 0 ? void 0 : instance.proxy.$tours.eventLevelNavigationTour.start();
    }
    function calculateHiddenClass(type) {
      switch (type) {
        case 'events':
          return !canAccessEvents.value;
        case 'sales':
          return !canAccessSales.value;
        case 'marketplace':
          return !canAccessMarketplace.value;
        case 'collectibles':
          return !canAccessCollectibles.value;
        case 'organization':
          return !canAccessOrganization.value;
        case 'platformAdmin':
          return !canAccessPlatformAdmin.value;
      }
    }
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _route$params, _organizers$value, _organizers$value2;
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!auth.loggedIn) {
              router.replace('/');
            }
            bus.$on('getEventData', getEvent);
            if ((_route$params = route.params) !== null && _route$params !== void 0 && _route$params.id) {
              getEvent();
            }
            organizer.value = getOrganizer.value;
            organizers.value = getOrganizers.value;

            // Handles the issue with the profile page of regular users failing since they have no organizers
            if (!(((_organizers$value = organizers.value) === null || _organizers$value === void 0 ? void 0 : _organizers$value.length) > 0)) {
              _context.next = 1;
              break;
            }
            _context.next = 1;
            return changeToOrg(organizer.value.name);
          case 1:
            handleTopLevelTour();
            bus.$on('getEventData', handleEventLevelTour);
            bus.$on('helpButtonClicked', handleHelpClick);
            if (!(((_organizers$value2 = organizers.value) === null || _organizers$value2 === void 0 ? void 0 : _organizers$value2.length) > 0 && runtimeConfig.featurebaseAppId)) {
              _context.next = 3;
              break;
            }
            _context.next = 2;
            return nextTick();
          case 2:
            _context.next = 3;
            return instance === null || instance === void 0 ? void 0 : instance.proxy.$featurebase();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    onBeforeUnmount(function () {
      bus.$off('getEventData');
      bus.$off('helpButtonClicked');
    });
    return {
      __sfc: true,
      userStore: userStore,
      appStore: appStore,
      eventsStore: eventsStore,
      route: route,
      router: router,
      auth: auth,
      sdk: sdk,
      notifier: notifier,
      t: t,
      locale: locale,
      localePath: localePath,
      whitelabel: whitelabel,
      whitelabelLite: whitelabelLite,
      featureFlags: featureFlags,
      runtimeConfig: runtimeConfig,
      bus: bus,
      instance: instance,
      eventStates: eventStates,
      eventTypes: eventTypes,
      event: event,
      organizers: organizers,
      organizer: organizer,
      handleTopLevelTourFinish: handleTopLevelTourFinish,
      handleEventLevelTourFinish: handleEventLevelTourFinish,
      topLevelTourSteps: topLevelTourSteps,
      eventLevelTourSteps: eventLevelTourSteps,
      topLevelTourCallbacks: topLevelTourCallbacks,
      eventLevelTourCallbacks: eventLevelTourCallbacks,
      canInviteUser: canInviteUser,
      hasRoleForOrg: hasRoleForOrg,
      canAccessMyEvents: canAccessMyEvents,
      canAccessLocation: canAccessLocation,
      canAccessTransactionRules: canAccessTransactionRules,
      canAccessOrganizer: canAccessOrganizer,
      canAccessUsers: canAccessUsers,
      canAccessEventInfo: canAccessEventInfo,
      canAccessReporting: canAccessReporting,
      canAccessSendTickets: canAccessSendTickets,
      canAccessViewOrders: canAccessViewOrders,
      canAccessSoldTickets: canAccessSoldTickets,
      canAccessSendEmails: canAccessSendEmails,
      canAccessManageAccounts: canAccessManageAccounts,
      canAccessNFTCollectibles: canAccessNFTCollectibles,
      canSendEventNotifications: canSendEventNotifications,
      canSendGlobalNotifications: canSendGlobalNotifications,
      canAccessOrganizerApplications: canAccessOrganizerApplications,
      canAccessEventPayouts: canAccessEventPayouts,
      getUser: getUser,
      getDashboardMenu: getDashboardMenu,
      getDashboardMenuActive: getDashboardMenuActive,
      getEventSendTickets: getEventSendTickets,
      getOrganizer: getOrganizer,
      getOrganizers: getOrganizers,
      getOrganizerInToken: getOrganizerInToken,
      getLoading: getLoading,
      userCanAccessDashboard: userCanAccessDashboard,
      getCurrentEvent: getCurrentEvent,
      canAccessEvents: canAccessEvents,
      canAccessSales: canAccessSales,
      canAccessMarketplace: canAccessMarketplace,
      canAccessCollectibles: canAccessCollectibles,
      canAccessOrganization: canAccessOrganization,
      canAccessPlatformAdmin: canAccessPlatformAdmin,
      isMainOrg: isMainOrg,
      isRecurring: isRecurring,
      isOccurrence: isOccurrence,
      isDraft: isDraft,
      isEdit: isEdit,
      headerColor: headerColor,
      isRuleEditPage: isRuleEditPage,
      eventHasTicketConfigs: eventHasTicketConfigs,
      userMenuItems: userMenuItems,
      menuItems: menuItems,
      eventUrl: eventUrl,
      eventMenuItems: eventMenuItems,
      profileMenuItems: profileMenuItems,
      urlHasEventId: urlHasEventId,
      logoUrl: logoUrl,
      emailVerified: emailVerified,
      getEvent: getEvent,
      organizerSelected: organizerSelected,
      changeToOrg: changeToOrg,
      gotoHome: gotoHome,
      gotoEvents: gotoEvents,
      handleTopLevelTour: handleTopLevelTour,
      handleEventLevelTour: handleEventLevelTour,
      handleHelpClick: handleHelpClick,
      calculateHiddenClass: calculateHiddenClass,
      BHeader: BHeader,
      BSelect: BSelect,
      BLoader: BLoader,
      BAlert: BAlert,
      DashboardMenuState: DashboardMenuState
    };
  }
});